export const defaultTabsConfig = {
    afterActive: function($activeItem, $visibleCard, $tabs) {
        const $sliders = $visibleCard.find('.js-icube-slider');
        const $icubeSliders = $sliders.filter('[data-slider]');
        const $slick = $sliders.filter('[data-slick]');
        const $grid = $visibleCard.find('[data-rwd]');
        const $scroller = $visibleCard.find('.ci-scroller');

        if ($icubeSliders.length) {
            $icubeSliders.each(function() {
                this.icubeSlider.refresh();
            });
        }

        if ($slick.length) {
            $slick.each(function() {
                const $self = $(this);

                $self.slick('refresh');
                $self.trigger('icube.slick.refresh');
            });
        }

        if ($grid.length) {
            $grid.trigger('icube.module.grid.resize');
        }

        if ($scroller.length) {
            $scroller.trigger('icube.scroller.resize');
        }
    }
}